export const LOCAL_STORAGE_KEYS = {
  LOAN_DRILLDOWN: {
    SHOW_TREE_MAP: "app.loanDrilldown.showTreeMap",
  },
  LOAN_PIPELINE_TABLE: {
    DEFAULT_TABLE_SORT: "app.loanPipelineTable.defaultTableSort",
    DEFAULT_TABLE_STATUS_FILTER:
      "app.loanPipelineTable.defaultTabletatusFilter",
    DEFAULT_TABLE_PIPELINE_FILTER:
      "app.loanPipelineTable.defaultTablePipelineFilter",
    DEFAULT_TABLE_SALESPERSON_FILTER:
      "app.loanPipelineTable.defaultTableSalespersonFilter",
    DEFAULT_TABLE_PIPELINE_FILTER_COLLAPSED:
      "app.loanPipelineTable.defaultTablePipelineFilterCollapsed",
    SAVED_COLUMN_DEFS: "app.loanPipelineTable.savedColumnDefs",
  },
};
